import { Component, OnInit } from '@angular/core';
import {
  ABTest,
  EnrolmentProportion,
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '@freelancer/abtest';

@Component({
  selector: 'webapp-compat-abtest',
  template: `
    <ng-container></ng-container>
  `,
})
export class CompatABTestComponent implements OnInit {
  constructor(private abtest: ABTest) {}

  ngOnInit() {
    const w = window as any;
    w.webappCompatABTest = {
      getSessionExperimentVariation: (name: keyof SessionExperiments) =>
        this.abtest.getSessionExperimentVariation(name).toPromise(),
      getUserExperimentVariation: (
        name: keyof UserExperiments,
        userId?: number,
      ) => this.abtest.getUserExperimentVariation(name, userId).toPromise(),
      getProjectExperimentVariation: (
        name: keyof ProjectExperiments,
        projectId: number,
      ) =>
        this.abtest.getProjectExperimentVariation(name, projectId).toPromise(),
      shouldEnrol: (
        name: keyof ProjectExperiments,
        contextId: number | string,
        testProportion: EnrolmentProportion,
      ) => this.abtest.shouldEnrol(name, contextId, testProportion),
    };
    if (w.webappCompatABTestReadyCallback) {
      w.webappCompatABTestReadyCallback();
    }
  }
}
